import StaggerText from "react-stagger-text";
import "./heroscreen.css";
import "./scroller.css";
import { motion } from "framer-motion";
import { useRef } from "react";

export default function HeroScreen({ loading }) {
  const homeRef = useRef(null);
  const technologies = ["NextJS","ReactJS", "NodeJS", "Flutter"];
  return (
    <div id="home" ref={homeRef} className="heroSection">
      <div className="background-image"></div>
      {!loading && (
        <div class="content">
          <motion.div
            initial={{
              opacity: 0,
              x: -500,
            }}
            transition={{
              duration: 1,
              delay: 0,
            }}
            animate={{ opacity: 1, x: 0 }}
          >
            <p className="heading">
              <StaggerText
                hasInlineBlockWrapper
                staggerType="letter"
                staggerDelay={0.1}
                startDelay={10}
                shouldStart={true}
                staggerEasing="ease-in"
                startTreshold={0.1}
              >
                Abdul Saboor
              </StaggerText>
            </p>
          </motion.div>

          <motion.div
            initial={{
              opacity: 0,
              y: 20,
            }}
            transition={{
              duration: 0.2,
              delay: 3,
            }}
            animate={{ opacity: 1, y: 0 }}
            style={{ paddingTop: 1 }}
          >
            <p className="f-stack">
              <b> Full Stack Developer </b>
            </p>
          </motion.div>

          <div className="tech-list">
            {" "}
            <ul className="p-0">
              {technologies.map((tech, index) => (
                <li key={index} className="tech-item">
                  <StaggerText
                    hasInlineBlockWrapper
                    staggerType="letter"
                    staggerDelay={0.2}
                    startDelay={1000}
                    shouldStart={true}
                    staggerEasing="ease-in"
                    startTreshold={0.1}
                  >
                    {tech}
                  </StaggerText>
                </li>
              ))}
            </ul>
          </div>
          <div className="scroller-index">
            <a href="#about" id="mouse-scroll">
              <motion.div
                initial={{
                  opacity: 0,
                  y: 20,
                }}
                transition={{
                  duration: 0.6,
                  delay: 1.5,
                }}
                animate={{ opacity: 1, y: 0 }}
              >
                <div class="mouse">
                  <div class="mouse-in"></div>
                </div>
                <div className="mt-2">
                  <span class="down-arrow-1"></span>
                  <span class="down-arrow-2"></span>
                  {/*  <!--         <span class="down-arrow-3"></span> --> */}
                </div>
              </motion.div>
            </a>
          </div>
        </div>
      )}

      <div className="gradient-background"></div>
    </div>
  );
}
